import { QueryClient, MutationCache } from '@tanstack/react-query';
import { toast } from 'react-toastify';

/**
 * Shared QueryClient instance.
 *
 * Defaults:
 *  - staleTime 30s  — list screens stay fresh without background refetch noise
 *  - retry 1        — one retry on network error (api.js already retries twice,
 *                     so this is a safety net only)
 *  - refetchOnWindowFocus true — snaps data back to current after tab switch
 *
 * MutationCache.onError — global fallback so silent mutation failures never go
 *  unnoticed. Individual mutations can still add their own onError for custom
 *  handling; this fires only when they don't.
 */
const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onError: (error: unknown) => {
      const message =
        error instanceof Error
          ? error.message
          : 'An error occurred. Please try again.';
      toast.error(message);
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
});

export default queryClient;
